// ─────────────────────────────────────────────────────────────────────────────
// Hardwired U.S. tax / retirement constants.
//
// These are sensible built-in defaults so a new signup doesn't have to look them
// up — every one is overridable per member/plan in the Setup tab. Update the
// values (and TAX_YEAR) when the IRS publishes new limits.
// ─────────────────────────────────────────────────────────────────────────────

export const TAX_YEAR = 2026;

/** Traditional/Roth IRA annual contribution limit (under age 50). */
export const IRS_IRA_LIMIT = 7000;
/** Additional IRA contribution allowed at age 50+. */
export const IRS_IRA_CATCHUP = 1000;
/** 401(k) elective-deferral annual limit (under age 50). */
export const IRS_401K_LIMIT = 23500;

/** FICA payroll tax: Social Security 6.2% + Medicare 1.45%. */
export const FICA_RATE = 0.0765;
